<template>
  <div id="app" v-wechat-title="$route.meta.title" img-set="/static/favicon.ico">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  name: 'app',
  methods: {
  },
  data () {
    return {}
  },
  watch: {
  }
};
</script>


// WEBPACK FOOTER //
// src/App.vue